export const RADIO_RENDERER_TYPE = '@sportsbook/radio';
export const LINK_RENDERER_TYPE = '@sportsbook/link';
export const MEDIA_RENDERER_TYPE = '@sportsbook/media';
export const SETTINGS_RENDERER_TYPE = '@sportsbook/settings';
export const ODDS_RENDERER_TYPE = '@sportsbook/odds';
export const FEEDBACK_RENDERER_TYPE = '@sportsbook/feedback';
export const NESTED_LANGUAGE_RENDERER_TYPE = '@sportsbook/nested-language';
export const SEARCH_RENDERER_TYPE = '@sportsbook/search';
